import React from "react";
import { Helmet } from "react-helmet";
import "./Legal.css";

export const TOS = () => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pageUrl = `${origin}/tos`;
  const description = "Read the FlintHost Terms of Service for all game hosting products.";
  return (
    <div className="legal-page">
      <Helmet>
        <title>FlintHost | Terms of Service</title>
        <meta name="description" content={description} />
        <meta property="og:title" content="FlintHost | Terms of Service" />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={`${origin}/img/Logo2.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FlintHost | Terms of Service" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={`${origin}/img/Logo2.png`} />
      </Helmet>
      <div className="legal-hero">
        <p className="legal-eyebrow">Legal</p>
        <h1>Terms of Service</h1>
        <p>Effective date: 1 January 2026</p>
      </div>
      <div className="legal-nav">
        <a href="/tos" aria-current="page">Terms of Service</a>
        <a href="/privacy">Privacy Policy</a>
        <a href="/acceptable-use">Acceptable Use</a>
        <a href="/refunds">Refund Policy</a>
      </div>
      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Agreement</h2>
          <p>
            These Terms of Service govern your access to FlintHost services, including Minecraft, Hytale,
            and other supported games. By creating an account or using the service, you agree to these terms.
            If you are in the EEA, you also agree that any mandatory consumer rights under local law remain in force.
          </p>
        </section>
        <section className="legal-section">
          <h2>2. Services</h2>
          <p>
            FlintHost provides game server hosting, control panel tools, and related infrastructure. Features may
            vary by game and plan. We may update or improve services to maintain performance, security, and compatibility.
          </p>
        </section>
        <section className="legal-section">
          <h2>3. Accounts & Security</h2>
          <p>
            You are responsible for maintaining account security and for activity that occurs under your credentials.
            Notify us immediately if you suspect unauthorized access.
          </p>
        </section>
        <section className="legal-section">
          <h2>4. Billing & Taxes</h2>
          <p>
            Plans renew automatically until cancelled. Prices are shown before purchase and may include applicable VAT
            or other taxes based on your location. You are responsible for ensuring payment methods remain current.
          </p>
        </section>
        <section className="legal-section">
          <h2>5. Cancellations & Refunds</h2>
          <p>
            You may cancel at any time from the client panel. Refunds are handled under our Refund Policy, which also
            covers EU withdrawal rights for digital services.
          </p>
        </section>
        <section className="legal-section">
          <h2>6. Acceptable Use</h2>
          <p>
            Use of our services must comply with our Acceptable Use Policy and the rules of any game or platform.
            We may suspend or terminate services that violate these requirements.
          </p>
        </section>
        <section className="legal-section">
          <h2>7. Service Availability & Backups</h2>
          <p>
            We aim for high availability, but scheduled maintenance or unforeseen incidents can occur. We recommend
            maintaining offsite backups. FlintHost is not responsible for data loss caused by issues beyond our control.
          </p>
          <p>
            If your chosen location is temporarily full at provisioning time, we may place your server in an alternative
            location until capacity becomes available in your requested region. During this temporary placement, you are
            eligible for service credit at 10% per day, capped at a maximum of 50% total credit for the affected billing period.
          </p>

        </section>
        <section className="legal-section">
          <h2>8. Intellectual Property</h2>
          <p>
            FlintHost retains all rights to its platform, branding, and software. You retain rights to your content.
            You grant us a limited license to host and process your content to provide the services.
          </p>
        </section>
        <section className="legal-section">
          <h2>9. Suspension & Termination</h2>
          <p>
            We may suspend or terminate services for non-payment, abuse, illegal activity, or security risks.
            You may terminate your account at any time by cancelling all active services.
          </p>
        </section>
        <section className="legal-section">
          <h2>10. Liability</h2>
          <p>
            To the extent permitted by law, FlintHost is not liable for indirect, incidental, or consequential damages.
            For consumers in the EEA, statutory liability rights remain unaffected.
          </p>
        </section>
        <section className="legal-section">
          <h2>11. Changes</h2>
          <p>
            We may update these terms to reflect changes in services or legal requirements. We will post the updated
            terms on this page and update the effective date.
          </p>
        </section>
        <section className="legal-section">
          <h2>12. Contact</h2>
          <p>
            Questions about these terms? Contact us at <a href="mailto:contact@flinthost.com">contact@flinthost.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};
